import { useCallback } from "react"
import { FieldError } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { ParseKeys } from "i18next"

export function useFormValidationMessage() {
  const { t } = useTranslation()

  return useCallback(
    (
      fieldError: FieldError | null | undefined,
      label: string | undefined,
      variables?: Record<string, string | number | undefined | null>
    ) => {
      if (fieldError?.message) {
        return fieldError?.message
      }

      return fieldError
        ? (t(`Validation.${fieldError.type}` as ParseKeys, {
            fieldName: label,
            ...variables
          }) as string)
        : undefined
    },
    [t]
  )
}
